<template>
    <li :id="card.filename" class="tcu-card _profile | tcu-directory-card" @click="selectProfile">

      <div class="tcu-card-img | tcu-directory-card__image-wrapper">
          <img v-if="card.image" v-lazyload :data-url="'https://www.tcu.edu/' + card.image" :alt="card.name" class="tcu-card__image | tcu-directory-card__image">
          <img v-else v-lazyload data-url="https://www.tcu.edu/directory/images/leadon-default-headshot-mobile.jpg" alt="" class="tcu-card__image | tcu-directory-card__image">
          <spinner />
      </div>

      <div class="tcu-card__info | tcu-directory-card__content">
          <div class="group">
            <span class="tcu-profile-card__name | tcu-directory-card__name"><a ref="focusEl" :href="userLink" v-on:click.prevent>{{ card.name }}</a></span><br />
            <span class="tcu-profile-card__title | tcu-directory-card__title">{{ card.jobTitle }}</span>
          </div>
          <span class="tcu-profile-card__email | tcu-directory-card__icon">
            <template v-if="card.email">
            <svg class="tcu-email-icon" focusable="false" height="24" width="24"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icon-email-icon" xlink:href="#icon-email-icon"></use></svg>
            <a v-on:click.stop :href="'mailto:' + card.email">{{ card.email }}</a>
            </template>
          </span>
          <span class="tcu-profile-card__telephone | tcu-directory-card__icon">
            <template v-if="card.telephone" >
            <svg class="tcu-phone-icon" focusable="false" height="24" width="24"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icon-phone-icon" xlink:href="#icon-phone-icon"></use></svg>
            {{ card.telephone }}
            </template>
          </span>
          <!-- Debugging: {{ card.keywords }} -->
      </div>
    </li>
    <!--/ End .tcu-card._profile -->
</template>

<script>
import Spinner from "./Spinner";
import store from "../store";
export default {
  components: {
    "spinner": Spinner,
  },
  data() {
    return {};
  },
  mounted(){
    if(this.focused) {
      this.$refs.focusEl.focus();
    }
  },
  computed: {
    userLink() {
      return store.config.profilePath + '/' + this.card.filename;
    }
  },
  methods: {
    selectProfile(e) {
      this.$emit('selectProfile', this.card)
    },
  },
  props: {
    // this component expects a prop of type object
    card: Object,
    focused: Boolean
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ProfileCard.vue